/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import forYouSVG from './assets/for-you-skeleton.tpl.svg';

const containerStyles = {
	width: '100%',
	maxWidth: '1232px',
	marginInline: 'auto',
};

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: 0,
	},
});

export const ForYouSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={forYouSVG} containerStyles={containerStyles} css={customCssStyles} />
);
